import { classNamePrefix } from '../globals';
import { TFunction } from '../types';

export function renderButton (label: string, callback: TFunction, parentClass?:string) {
    const className = classNamePrefix + '-button';

    const buttonElement = document.createElement('button');
    buttonElement.classList.add(className);
    buttonElement.role = 'button';
    buttonElement.innerHTML = label;
    buttonElement.addEventListener('click', callback);

    if (parentClass) {
        buttonElement.classList.add(parentClass);
    }

    return buttonElement;
}